import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Button from "@/v2-backoffice-client/components/button"
import { useTableContext } from "./table.context"
import { getColumnTitle } from "./table.utils"

export type TableGroupListProps = ComponentProps<"div">

function TableGroupList(props: TableGroupListProps) {
  const { className, ...divProps } = props
  const { table } = useTableContext()

  const { grouping } = table.getState()
  if (grouping.length === 0) return null

  return (
    <div className={cn("ui-table-active-filters", className)} {...divProps}>
      <span className="ui-table-active-filters-label">Grouped by:</span>

      {grouping.map((columnId) => {
        const column = table.getColumn(columnId)
        if (!column) return null

        return (
          <Button
            key={columnId}
            className="ui-table-active-filters-badge"
            variant="secondary"
            size="xs"
            iconSrc="cross-small"
            iconPosition="right"
            iconClassName="ui-table-icon-sm"
            onClick={() => {
              table.setGrouping((prev) => prev.filter((id) => id !== columnId))
            }}
          >
            <span>{getColumnTitle(column)}</span>
          </Button>
        )
      })}

      <Button
        className="ui-table-active-filters-clear"
        variant="ghost"
        size="xs"
        onClick={() => {
          table.resetGrouping()
        }}
      >
        Clear
      </Button>
    </div>
  )
}

export default TableGroupList
